// extracted by mini-css-extract-plugin
module.exports = {"text":"Widget_text__ZmwyS"};